interface ComplianceLogEvent {
  id: string;
  content: ComplianceLogEventContent;
  createdAt: string;
  actionBy: { userId: string; type: string };
}

enum ComplianceLogEventType {
  AttachmentRedacted = 'ATTACHMENT_REDACTED',
  ConversationDeleted = 'CONVERSATION_DELETED',
  ConversationItemRedacted = 'CONVERSATION_ITEM_REDACTED',
  CustomerProfileExported = 'CUSTOMER_PROFILE_EXPORTED',
  Data_retentionConfigUpdated = 'DATA_RETENTION_CONFIG_UPDATED',
  ProfileDeleted = 'PROFILE_DELETED',
  RecordingRedacted = 'RECORDING_REDACTED',
}

interface ComplianceLogEventContent {
  type: ComplianceLogEventType;
  customerId: string;
}

export default ComplianceLogEvent;

export const complianceTypeToText = Object.freeze(() => ({
  [ComplianceLogEventType.AttachmentRedacted]: 'Deleted an attachment',
  [ComplianceLogEventType.ConversationDeleted]: 'Deleted a Conversation and all of its items',
  [ComplianceLogEventType.ConversationItemRedacted]: 'Deleted a Conversation item',
  [ComplianceLogEventType.CustomerProfileExported]: 'Downloaded a Customer JSON file',
  [ComplianceLogEventType.Data_retentionConfigUpdated]: 'Updated Customer Data Retention settings',
  [ComplianceLogEventType.ProfileDeleted]: 'Deleted a Customer Profile',
  [ComplianceLogEventType.RecordingRedacted]: 'Deleted a call recording',
}));
